import React, { memo, useState } from 'react';
import { searchByCPFOrCNPJ } from '../../../../api/clientSearch';
import {
  limparDocumento,
  formatarDocumento,
  CPFMask,
  CNPJMask,
  CPFCNPJMask
} from '../../../../utils/documentoAlfanumerico';
import CustomMaskedInput from '../CustomMaskedInput/CustomMaskedInput';

const CPFCNPJInput = props => {
  const { onSearch, searchHandler, mascaraEspecifica, maxLength = 18, ...otherProps } = props;
  const [loading, setLoading] = useState(false);
  let applyMask = CPFCNPJMask;

  if (mascaraEspecifica === 'CPF') {
    applyMask = CPFMask;
  } else if (mascaraEspecifica === 'CNPJ') {
    applyMask = CNPJMask;
  }

  const searchDocument = stripped => {
    let propriedades = props;
    const documentoCompleto = stripped.length === 11 || stripped.length === 14;
    if (documentoCompleto) {
      if (onSearch && !propriedades.form.isSubmitting) {
        setLoading(true);
        searchHandler(stripped)
          .then(res => {
            onSearch(res.data, otherProps.form, otherProps.field);
          })
          .finally(() => {
            setLoading(false);
          })
          .catch(() => {
            onSearch([], otherProps.form, otherProps.field);
          });
      }
    }
  };

  const handlePaste = e => {
    const valorColado = e.clipboardData.getData('Text');
    const stripped = limparDocumento(valorColado);

    searchDocument(stripped);
    otherProps.form.setFieldValue(otherProps.field.name, formatarDocumento(valorColado));
    e.preventDefault();
  };

  const handleInputChange = event => {
    if (!event || !event.target) return;

    const valorFormatado = formatarDocumento(event.target.value);
    event.target.value = valorFormatado;

    if (otherProps.field && typeof otherProps.field.onChange === 'function') {
      otherProps.field.onChange(event);
    } else {
      otherProps.form.setFieldValue(otherProps.field.name, valorFormatado);
    }
  };

  const handleChange = e => {
    const valorFormatado = formatarDocumento(otherProps.field.value);

    if (e.keyCode !== 9) {
      const stripped = limparDocumento(valorFormatado);

      searchDocument(stripped);
    }

    let propriedades = props;
    if (limparDocumento(propriedades.field.value) === '' && onSearch) {
      onSearch(null, otherProps.form, otherProps.field);
    }
  };

  return (
    <div className="loadingWrapper">
      <CustomMaskedInput
        maxLength={maxLength}
        onKeyUp={handleChange}
        onPaste={handlePaste}
        {...otherProps}
        onChange={handleInputChange}
        mask={applyMask}
      />
      {loading && (
        <>
          <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
          <span className="sr-only">Carregando...</span>
        </>
      )}
    </div>
  );
};

CPFCNPJInput.defaultProps = {
  searchHandler: searchByCPFOrCNPJ
};

export default memo(CPFCNPJInput);
